(function(Modal) {
    'use strict';

    Modal.elements = {
        gallery: '.js-modal-gallery',
        inline: '.js-modal'
    };

    Modal.gallery = function() {
        $(Modal.elements.gallery).magnificPopup({
            type: 'image',
            gallery: {
                enabled: true
            },
            callbacks: {
                change: function() {
                    if (this.isOpen) {
                        this.wrap.addClass('mfp-open');
                    }
                }
            }
        });
    };

    Modal.inline = function() {
        $(Modal.elements.inline).magnificPopup({
            type: 'inline'
        });
    };
})(window.Way2web.Modal = window.Way2web.Modal || {});
